import React, { useState, useMemo } from 'react';
import { X, Plus } from 'lucide-react';

const CORE_ORDER = ['B', 'D', 'Zh', 'Z', 'I', 'L', 'G', 'M', 'A', 'K', 'V', 'E', 'HRT', 'Man', 'SUN'];
const DEFAULT_LABELS = {
  B: { letter: 'Б', desc: 'Ay' }, D: { letter: 'Д', desc: 'NƏ1' },
  Zh: { letter: 'Ж', desc: 'NƏ3' }, Z: { letter: 'З', desc: 'NƏ4' },
  I: { letter: 'И', desc: 'KD1' }, L: { letter: 'Л', desc: 'KD3' },
  G: { letter: 'Г', desc: 'Yekun' }, M: { letter: 'М', desc: 'KD4' },
  A: { letter: 'А', desc: 'Gün' }, K: { letter: 'К', desc: 'KD2' },
  V: { letter: 'В', desc: 'İl' }, E: { letter: 'Е', desc: 'NƏ2' },
  HRT: { letter: 'HRT', desc: 'Heart' }, Man: { letter: 'Man', desc: 'Manipura' },
  SUN: { letter: '☀', desc: 'Sun' },
};

const ConnectionEditor = ({ connections, nodeLabels, onChange }) => {
  const [fromNode, setFromNode] = useState('');
  const [toNode, setToNode] = useState('');

  const nodeOptions = useMemo(() => {
    const allLabels = { ...DEFAULT_LABELS, ...(nodeLabels || {}) };
    const fromLabels = Object.keys(allLabels);
    const ordered = [
      ...CORE_ORDER.filter(id => id in allLabels),
      ...fromLabels.filter(id => !CORE_ORDER.includes(id)),
    ];
    return ordered.map(id => {
      const l = allLabels[id] || { letter: id, desc: '' };
      const labelText = l.desc ? `${l.letter} (${l.desc})` : l.letter;
      return { id, label: labelText };
    });
  }, [nodeLabels]);

  const getNodeLabel = (id) => {
    const n = nodeOptions.find(o => o.id === id);
    return n ? n.label : id;
  };

  const handleRemove = (index) => {
    const newConns = connections.filter((_, i) => i !== index);
    onChange(newConns);
  };

  const handleAdd = () => {
    if (!fromNode || !toNode || fromNode === toNode) return;
    const exists = connections.some(
      c => (c[0] === fromNode && c[1] === toNode) || (c[0] === toNode && c[1] === fromNode)
    );
    if (exists) return;
    onChange([...connections, [fromNode, toNode]]);
    setFromNode('');
    setToNode('');
  };

  return (
    <div className="admin-section">
      <h3 className="admin-section-title">Sfera bağlantıları (xətlər)</h3>
      <p className="admin-section-desc">Sferalar arasında xətləri əlavə edin və ya silin</p>

      <div className="conn-add-row">
        <select
          className="conn-select"
          value={fromNode}
          onChange={e => setFromNode(e.target.value)}
        >
          <option value="">Seçin...</option>
          {nodeOptions.map(n => (
            <option key={n.id} value={n.id}>{n.label}</option>
          ))}
        </select>
        <span className="conn-arrow">↔</span>
        <select
          className="conn-select"
          value={toNode}
          onChange={e => setToNode(e.target.value)}
        >
          <option value="">Seçin...</option>
          {nodeOptions.filter(n => n.id !== fromNode).map(n => (
            <option key={n.id} value={n.id}>{n.label}</option>
          ))}
        </select>
        <button
          onClick={handleAdd}
          disabled={!fromNode || !toNode || fromNode === toNode}
          className="conn-add-btn"
        >
          <Plus size={16} /> Əlavə
        </button>
      </div>

      <div className="conn-list">
        <div className="conn-count">Toplam: {connections.length} bağlantı</div>
        {connections.map((conn, i) => (
          <div key={`${conn[0]}-${conn[1]}-${i}`} className="conn-item">
            <span className="conn-node">{getNodeLabel(conn[0])}</span>
            <span className="conn-line-icon">—</span>
            <span className="conn-node">{getNodeLabel(conn[1])}</span>
            <button
              onClick={() => handleRemove(i)}
              className="conn-remove"
              title="Sil"
            >
              <X size={14} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ConnectionEditor;

